<template>
  <div class="sliderMain">
    <div class="sliderMain--content">
      <SliderArticles/>
    </div>
    <div class="sliderMain--nav">
      <SliderNav/>
    </div>
  </div>
</template>

<script>
import SliderArticles from '@/templates/_SliderArticles'
import SliderNav from '@/templates/_SliderNav'

export default {
  name: 'SliderMain',
  components: {
    SliderArticles,
    SliderNav
  }
}
</script>

<style>

</style>
